// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__zMyYC","container":"loading_container__R+cBo","move":"loading_move__nE6ux"};